import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { Header, Girder } from './components'

const Member = {
  joist: Header,
  truss: Girder,
  multiTruss: Girder,
}

const CarryingMember = (props) => {
  const { connectionType } = props

  return React.createElement(Member[connectionType], { ...props })
}

CarryingMember.propTypes = {
  connectionType: PropTypes.string.isRequired,
}

export default memo(CarryingMember)
